function getJSON(key, fallback, validator = null) {
  let parsed = null
  try {
    const raw = window.localStorage.getItem(key)
    if (raw != null) {
      parsed = JSON.parse(raw)
    }
  } catch {
    parsed = null
  }
  let valid = parsed !== undefined
  if (valid && validator != null) {
    valid = validator(parsed)
  }
  if (valid) {
    return parsed
  }
  window.localStorage.removeItem(key)
  return fallback
}

function setJSON(key, value) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value))
  } catch {
    // Storage full/unavailable: ignore, value just won't persist.
  }
}

const is_array_of_objects = value => Array.isArray(value) && value.every(item => item != null && typeof item === 'object')
const is_array_of_strings = value => Array.isArray(value) && value.every(item => typeof item === 'string')
const is_object_or_null = value => (value == null || (typeof value === 'object' && !Array.isArray(value)))
const is_boolean = value => typeof value === 'boolean'
const is_string_or_null = value => value == null || typeof value === 'string'
const is_string = value => typeof value === 'string'
const is_token = value => value != null && typeof value === 'object' && !Array.isArray(value) && typeof value.token === 'string' && value.token.length > 0

export default {getJSON, setJSON, is_array_of_objects, is_array_of_strings, is_object_or_null, is_boolean, is_string_or_null, is_string, is_token}
